import React from 'react';
import { ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { checklistTemplatesService } from '../../services';

export const ChecklistTemplatesFormPage: React.FC = () => {
  return (
    <ResourceFormPage
      title="Template de Checklist"
      service={checklistTemplatesService}
      redirectPath="/admin/logistica/checklist-templates"
      fields={[
        { name: 'nome', label: 'Nome', type: 'text', required: true },
        { name: 'ativo', label: 'Ativo', type: 'text' },
        // Note: itens array would need custom handling
      ]}
    />
  );
};
